import { ColumnDef } from '@tanstack/react-table';
import { Translator } from '../translator.type';

export type Receiver = {
  countCircuits: number;
  countDistributed: number;
  id: string;
  name: string;
  country: string;
};

export const RECEIVER_COLUMNS = (t: Translator): ColumnDef<Receiver>[] => [
  {
    accessorKey: 'name',
    header: t('receivers.columns.name'),
  },
  {
    accessorKey: 'country',
    header: t('receivers.columns.country'),
  },
  {
    accessorKey: 'countCircuits',
    header: t('receivers.columns.countCircuits'),
    cell: ({ row }) => (
      <span>
        {row.original.countCircuits > 0
          ? `${row.original.countDistributed}/${row.original.countCircuits}`
          : '-/-'}
      </span>
    ),
    enableSorting: false,
  },
];
